import moment from 'moment-timezone';

/**
 * Get the user's system timezone
 */
export const getUserSystemTimezone = (): string => {
  return moment.tz.guess(true);
};
